// Generic CSV download.
//   columns: [{ label, key?, accessor?(row)->value, fmt?(value,row)->string }]
//   rows:    array of objects
export function downloadCsv(filename, columns, rows) {
  const esc = (v) => {
    const s = String(v == null ? "" : v);
    return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  };
  const lines = [columns.map((c) => esc(c.label)).join(",")];
  (rows || []).forEach((r) => {
    lines.push(
      columns
        .map((c) => {
          const val = typeof c.accessor === "function" ? c.accessor(r) : r[c.key];
          return esc(c.fmt ? c.fmt(val, r) : val);
        })
        .join(",")
    );
  });
  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const name = filename.endsWith(".csv") ? filename : filename + ".csv";
  const a = Object.assign(document.createElement("a"), { href: url, download: name });
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
